import React from 'react'
import t from 'prop-types'
import { css } from 'linaria'
import cx from 'classnames'

const wysiwyg = css`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    @apply leading-tight font-sans font-bold text-gray-700 mt-16 mb-3;
    @screen md {
      @apply text-xl mt-20 mb-4;
    }
  }

  &.stacked-block + &.stacked-block {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      @apply mt-0;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    strong,
    b {
      @apply font-bold;
    }
  }

  p,
  ul,
  ol,
  li {
    @apply font-sans font-normal text-lg leading-normal text-gray-600 mb-3;
    @screen md {
      @apply text-xl mb-4;
    }
  }

  &.isOnDarkBg {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    ul,
    ol,
    li {
      @apply text-white;
    }
  }

  blockquote {
    @apply py-4 pl-4 my-12;
    border-left: 4px solid #0096fa;
    font-style: italic;
    p {
      @apply mb-0;
    }
    @screen md {
      @apply my-16;
    }
  }

  h1 {
    @apply text-4xl;
  }

  h2 {
    @apply text-3xl;
  }

  h3 {
    @apply text-2xl;
  }

  h4 {
    @apply text-xl;
  }

  h5 {
    @apply text-lg;
  }

  h6 {
    @apply text-base uppercase tracking-wider;
  }

  ul,
  ol {
    @apply pl-5;
  }

  ul {
    li {
      position: relative;
      margin-left: -16px;
      padding-left: 20px;
    }
    li:before {
      @apply bg-blue-200;
      content: '';
      height: 8px;
      width: 8px;
      min-height: 8px;
      min-width: 8px;
      position: absolute;
      top: 10px;
      left: 0;
    }
    ul {
      li:before {
        @apply overflow-hidden rounded-full bg-transparent border-blue-200 border-2;
      }
    }
  }

  ol {
    @apply list-decimal;
  }

  a {
    @apply text-blue-300;
    &:hover {
      @apply text-blue-200;
    }
  }

  img {
    @apply my-12;
    @screen md {
      @apply my-16;
    }
    &.my-0 {
      @apply my-0;
    }
  }

  figure {
    figcaption {
      @apply text-sm;
    }
  }

  .wp-block-separator {
    @apply w-48 h-1 mx-auto bg-gray-200 border-none my-24;
  }
`

export const Container = ({
  isStackedBlock,
  isOnDarkBg,
  children,
  ...args
}) => {
  return (
    <div
      className={cx(`${wysiwyg}`, {
        'stacked-block': isStackedBlock,
        'text-white isOnDarkBg': isOnDarkBg,
      })}
      {...args}
    >
      {children}
    </div>
  )
}

const WYSIWYG = ({ content, isOnDarkBg, isStackedBlock, children }) => {
  return (
    <Container
      className={cx(`${wysiwyg}`, {
        'stacked-block': isStackedBlock,
        'text-white isOnDarkBg': isOnDarkBg,
      })}
      {...(content ? { dangerouslySetInnerHTML: { __html: content } } : {})}
    >
      {children}
    </Container>
  )
}

WYSIWYG.propTypes = {
  content: t.arrayOf(t.element),
  isOnDarkBg: t.bool,
  isStackedBlock: t.bool,
}

WYSIWYG.defaultProps = {
  content: null,
  className: null,
  isOnDarkBg: false,
  isStackedHeading: false,
}

export default WYSIWYG
